export const EventStamp ={
	BLUMAR_RECOMMENDS: {src: `blumarRecommends.png`},
  SHUTTLE: {src: `shuttle.png`},
  SPECIAL_OFFER: {src: `specialOffer.png`},
  WALK: {src: `walk.png`},
}



// WEBPACK FOOTER //
// ./src/enums/EventStamp.js